<agr-page-toolbar
  [isEmpty]="(dosatorSettings$ | async)?.length === 0"
  [emptyTitle]="'settings.dosator-setting.no-dosatorsettings-title' | translate"
  [emptyDescription]="'settings.dosator-setting.no-dosatorsettings-description' | translate"
  emptyImage="assets/images/pigs_001.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="dosator-setting-overview"
>
  <ng-container
    *ngIf="(isLoading$ | async) === false && dosatorSettings$ | async as dosatorSettings"
  >
    <mat-nav-list role="list" *ngIf="dosatorSettings.length" class="dosator-setting-overview__list">
      <a
        mat-list-item
        role="listitem"
        class="dosatorSetting-item"
        data-test="dosatorSetting-overview__item"
        *ngFor="let dosatorSetting of dosatorSettings"
        (click)="openDosatorSettingEdit(dosatorSetting.id)"
      >
        <mat-icon matListItemAvatar class="list-avatar" svgIcon="mdi-barn"></mat-icon>
        <div matListItemTitle>{{ dosatorSetting.name }}</div>
        <div matListItemMeta>
          <button
            mat-icon-button
            (click)="delete($event, dosatorSetting)"
            data-test="dosator-setting-overview__delete-item"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </a>
      <mat-divider *ngIf="dosatorSettings.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
